import {
  STAGE1_STATUS,
  POST_BRIEFING_DECISION,
  BRIEFING_STATUS,
  STORAGE1_STATUS,
  BUNDLE_STATUS,
  SOURCE,
  DISPATCH_STATUS,
} from 'constants/status';

const img = (seed) => `https://picsum.photos/seed/${seed}/420/280`;

// Unified articles collection — workflow.current_stage drives which page sees each article.
export const MOCK_ARTICLES = [
  // ---- Stage 1 / pending ----
  {
    id: 'a-1',
    newspaper_name: 'Divya Bhaskar',
    edition: 'Ahmedabad',
    keywords: ['ગિરનાર', 'tourism'],
    article_title: 'Girnar ropeway sees record footfall this season',
    headline: 'ગિરનાર રોપવેમાં વિક્રમ',
    page_number: 3,
    language: 'gujarati',
    article_image_url: img('art-1'),
    newspaper_page_image_url: img('np-1'),
    merged_pdf_url: img('pdf-1'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.TELEGRAM, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage1', status: STAGE1_STATUS.PENDING, routing_destination: null, post_briefing_destination: null },
    approval: null,
    routing: null,
    created_at: '2026-06-29T07:05:00Z',
    created_by: 'cron-1',
  },
  {
    id: 'a-2',
    newspaper_name: 'Gujarat Samachar',
    edition: 'Vadodara',
    keywords: ['election', 'local body'],
    article_title: 'Local body elections announced for next month',
    headline: 'સ્થાનિક સ્વરાજ ચૂંટણી',
    page_number: 1,
    language: 'gujarati',
    article_image_url: img('art-2'),
    newspaper_page_image_url: img('np-2'),
    merged_pdf_url: img('pdf-2'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.EPAPER_PDF, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage1', status: STAGE1_STATUS.PENDING, routing_destination: null, post_briefing_destination: null },
    approval: null,
    routing: null,
    created_at: '2026-06-29T08:02:00Z',
    created_by: 'cron-2',
  },
  {
    id: 'a-3',
    newspaper_name: 'Sandesh',
    edition: 'Junagadh',
    keywords: ['infrastructure', 'municipality'],
    article_title: 'New civic infrastructure plan unveiled by municipality',
    headline: 'નવી નાગરિક માળખા યોજના',
    page_number: 5,
    language: 'gujarati',
    article_image_url: img('art-3'),
    newspaper_page_image_url: img('np-3'),
    merged_pdf_url: img('pdf-3'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.EPAPER_CHAT, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage1', status: STAGE1_STATUS.PENDING, routing_destination: null, post_briefing_destination: null },
    approval: null,
    routing: null,
    created_at: '2026-06-29T06:35:00Z',
    created_by: 'cron-3',
  },
  {
    id: 'a-4',
    newspaper_name: 'Divya Bhaskar',
    edition: 'Surat',
    keywords: ['જૈન', 'charity'],
    article_title: 'Jain community organises annual charity drive',
    headline: 'જૈન સમાજ દ્વારા વાર્ષિક દાન',
    page_number: 7,
    language: 'gujarati',
    article_image_url: img('art-4'),
    newspaper_page_image_url: img('np-4'),
    merged_pdf_url: img('pdf-4'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.MANUAL, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage1', status: STAGE1_STATUS.REJECTED, routing_destination: null, post_briefing_destination: null },
    approval: { rejected_by: 'user-4', rejected_by_name: 'Test User', rejected_at: '2026-06-28T10:05:00Z', rejection_reason: 'Out of scope' },
    routing: null,
    created_at: '2026-06-28T10:00:00Z',
    created_by: 'user-4',
  },
  {
    id: 'a-5',
    newspaper_name: 'Mid-Day',
    edition: 'Mumbai',
    keywords: ['electric buses', 'transport'],
    article_title: 'City transport gets new electric fleet of 200 buses',
    headline: 'New electric buses for city',
    page_number: 2,
    language: 'english',
    article_image_url: img('art-5'),
    newspaper_page_image_url: img('np-5'),
    merged_pdf_url: img('pdf-5'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.EPAPER_PDF, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage1', status: STAGE1_STATUS.PENDING, routing_destination: null, post_briefing_destination: null },
    approval: null,
    routing: null,
    created_at: '2026-06-29T09:15:00Z',
    created_by: 'cron-1',
  },

  // ---- Approved (still in stage1, visible in both Stage 1 and Stage 2) ----
  {
    id: 'a-6',
    newspaper_name: 'Divya Bhaskar',
    edition: 'Ahmedabad',
    keywords: ['expressway', 'infrastructure', 'CM'],
    article_title: 'CM inaugurates new expressway connecting Ahmedabad to Gandhinagar',
    headline: 'CM દ્વારા એક્સપ્રેસ-વે ઉદ્ઘાટન',
    page_number: 1,
    language: 'gujarati',
    article_image_url: img('art-6'),
    newspaper_page_image_url: img('np-6'),
    merged_pdf_url: img('pdf-6'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.TELEGRAM, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage2', status: 'approved', routing_destination: null, post_briefing_destination: null },
    approval: { approved_by: 'user-1', approved_by_name: 'Admin User', approved_at: '2026-06-28T08:00:00Z' },
    routing: null,
    created_at: '2026-06-27T07:00:00Z',
    created_by: 'cron-1',
  },
  {
    id: 'a-7',
    newspaper_name: 'Gujarat Samachar',
    edition: 'Ahmedabad',
    keywords: ['GIFT City', 'investment', 'economy'],
    article_title: 'GIFT City attracts ₹2 lakh cr in new investment pledges',
    headline: 'GIFT City રોકાણ',
    page_number: 1,
    language: 'gujarati',
    article_image_url: img('art-7'),
    newspaper_page_image_url: img('np-7'),
    merged_pdf_url: img('pdf-7'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.EPAPER_CHAT, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage2', status: 'approved', routing_destination: null, post_briefing_destination: null },
    approval: { approved_by: 'user-1', approved_by_name: 'Admin User', approved_at: '2026-06-27T09:00:00Z' },
    routing: null,
    created_at: '2026-06-26T08:00:00Z',
    created_by: 'cron-2',
  },
  {
    id: 'a-8',
    newspaper_name: 'Navbharat Times',
    edition: 'Mumbai',
    keywords: ['Mumbai', 'coastal road', 'infrastructure'],
    article_title: 'Coastal road project nears completion ahead of monsoon',
    headline: 'Mumbai coastal road करीब पूर्ण',
    page_number: 2,
    language: 'english',
    article_image_url: img('art-8'),
    newspaper_page_image_url: img('np-8'),
    merged_pdf_url: img('pdf-8'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.TELEGRAM, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'stage2', status: 'approved', routing_destination: null, post_briefing_destination: null },
    approval: { approved_by: 'user-1', approved_by_name: 'Admin User', approved_at: '2026-06-26T10:00:00Z' },
    routing: null,
    created_at: '2026-06-25T07:00:00Z',
    created_by: 'cron-3',
  },

  // ---- Briefing / routed ----
  {
    id: 'a-9',
    newspaper_name: 'Gujarat Samachar',
    edition: 'Vadodara',
    keywords: ['heritage', 'tourism', 'Vadodara'],
    article_title: 'Vadodara heritage walk route launched by tourism department',
    headline: 'વડોદરા હેરિટેજ વૉક',
    page_number: 6,
    language: 'gujarati',
    article_image_url: img('art-9'),
    newspaper_page_image_url: img('np-9'),
    merged_pdf_url: img('pdf-9'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.EPAPER_PDF, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'briefing', status: 'routed', routing_destination: 'briefing', post_briefing_destination: null },
    approval: { approved_by: 'user-1', approved_by_name: 'Admin User', approved_at: '2026-06-24T08:00:00Z' },
    routing: { routed_by: 'user-1', routed_by_name: 'Admin User', routed_at: '2026-06-24T09:00:00Z', notes: '' },
    created_at: '2026-06-23T07:00:00Z',
    created_by: 'cron-2',
  },
  {
    id: 'a-10',
    newspaper_name: 'Sandesh',
    edition: 'Rajkot',
    keywords: ['police', 'women safety', 'helpline'],
    article_title: 'Rajkot police launch women safety helpline with 24-hour response',
    headline: 'રાજકોટ પોલીસ મહિલા હેલ્પલાઇન',
    page_number: 2,
    language: 'gujarati',
    article_image_url: img('art-10'),
    newspaper_page_image_url: img('np-10'),
    merged_pdf_url: img('pdf-10'),
    merged_pdf_status: 'generated',
    source: { type: SOURCE.TELEGRAM, identifier: null },
    is_manual_upload: false,
    workflow: { current_stage: 'briefing', status: 'routed', routing_destination: 'briefing', post_briefing_destination: null },
    approval: { approved_by: 'user-1', approved_by_name: 'Admin User', approved_at: '2026-06-23T08:00:00Z' },
    routing: { routed_by: 'user-1', routed_by_name: 'Admin User', routed_at: '2026-06-23T09:00:00Z', notes: '' },
    created_at: '2026-06-22T07:00:00Z',
    created_by: 'cron-1',
  },
];

// Stage 1 history: own articles + approved (stage2) + routed (passed approval, moved to destination)
export const MOCK_STAGE1 = MOCK_ARTICLES.filter(
  (a) =>
    a.workflow.current_stage === 'stage1' ||
    (a.workflow.current_stage === 'stage2' && a.workflow.status === 'approved') ||
    (['briefing', 'storage1', 'storage2'].includes(a.workflow.current_stage) && a.workflow.status === 'routed'),
);
// Stage 2 history: approved (awaiting routing) + routed (already dispatched to destination)
export const MOCK_STAGE2 = MOCK_ARTICLES.filter(
  (a) => a.workflow.status === 'approved' || a.workflow.status === 'routed',
);

export const MOCK_BRIEFING = [
  {
    id: 'br-1',
    stage2_id: 's2-old-1',
    newspaper_name: 'Divya Bhaskar',
    edition: 'Rajkot',
    keyword: ['budget'],
    article_link: img('art-6'),
    newspaper_link: img('np-6'),
    page_number: 4,
    batch_id: null,
    post_briefing_decision: POST_BRIEFING_DECISION.PENDING,
    status: BRIEFING_STATUS.PENDING,
    created_at: '2026-06-29T05:00:00Z',
  },
  {
    id: 'br-2',
    stage2_id: 's2-old-2',
    newspaper_name: 'Gujarat Samachar',
    edition: 'Ahmedabad',
    keyword: ['મેટ્રો'],
    article_link: img('art-7'),
    newspaper_link: img('np-7'),
    page_number: 1,
    batch_id: 'batch-1',
    post_briefing_decision: POST_BRIEFING_DECISION.STORAGE1,
    status: BRIEFING_STATUS.DISPATCHED,
    created_at: '2026-06-28T05:00:00Z',
  },
];

export const MOCK_BRIEFING_SCHEDULE = {
  id: 'sched-1',
  windows: [
    { label: 'Morning', dispatch_time: '09:00' },
    { label: 'Evening', dispatch_time: '18:00' },
  ],
  dispatch_to: ['+919812345678', '+919898765432'],
  status: 'active',
};

export const MOCK_BRIEFING_BATCHES = [
  {
    id: 'batch-1',
    batch_number: 24,
    window_label: 'Morning',
    window_start: '2026-06-28T03:30:00Z',
    window_end: '2026-06-28T03:30:00Z',
    article_count: 6,
    merged_pdf_link: '#',
    dispatched_at: '2026-06-28T03:30:00Z',
    dispatched_to: ['+919812345678'],
    dispatch_status: DISPATCH_STATUS.SENT,
  },
  {
    id: 'batch-2',
    batch_number: 25,
    window_label: 'Evening',
    window_start: '2026-06-28T12:30:00Z',
    window_end: '2026-06-28T12:30:00Z',
    article_count: 3,
    merged_pdf_link: '#',
    dispatched_at: null,
    dispatched_to: [],
    dispatch_status: DISPATCH_STATUS.PENDING,
  },
];

export const MOCK_STORAGE1 = [
  {
    id: 'st1-1',
    stage2_id: 's2-old-3',
    source_module: 'stage2',
    newspaper_name: 'Divya Bhaskar',
    edition: 'Ahmedabad',
    keyword: ['ગિરનાર'],
    article_link: img('art-8'),
    newspaper_link: img('np-8'),
    merged_pdf_link: '#',
    merge_status: 'completed',
    bundle_id: 'bundle-1',
    page_number: 3,
    status: STORAGE1_STATUS.IN_BUNDLE,
    created_at: '2026-06-27T05:00:00Z',
  },
  {
    id: 'st1-2',
    stage2_id: 's2-old-4',
    source_module: 'briefing',
    newspaper_name: 'Divya Bhaskar',
    edition: 'Surat',
    keyword: ['budget'],
    article_link: img('art-9'),
    newspaper_link: img('np-9'),
    merged_pdf_link: null,
    merge_status: 'pending',
    bundle_id: null,
    page_number: 6,
    status: STORAGE1_STATUS.PENDING_MERGE,
    created_at: '2026-06-29T05:00:00Z',
  },
  {
    id: 'st1-3',
    stage2_id: 's2-old-5',
    source_module: 'stage2',
    newspaper_name: 'Gujarat Samachar',
    edition: 'Vadodara',
    keyword: ['election'],
    article_link: img('art-10'),
    newspaper_link: img('np-10'),
    merged_pdf_link: '#',
    merge_status: 'completed',
    bundle_id: null,
    page_number: 1,
    status: STORAGE1_STATUS.UNBUNDLED,
    created_at: '2026-06-29T06:00:00Z',
  },
];

export const MOCK_BUNDLES = [
  {
    id: 'bundle-1',
    bundle_number: 12,
    newspaper_name: 'Divya Bhaskar',
    article_count: 10,
    bundled_pdf_link: '#',
    excel_sheet_link: '#',
    dispatch_history: [
      { dispatched_at: '2026-06-26T10:00:00Z', dispatched_to: '+919812345678', requested_count: 2, dispatched_by: 'Sana Storage' },
    ],
    status: BUNDLE_STATUS.READY,
    created_at: '2026-06-26T05:00:00Z',
  },
  {
    id: 'bundle-2',
    bundle_number: 13,
    newspaper_name: 'Gujarat Samachar',
    article_count: 7,
    bundled_pdf_link: null,
    excel_sheet_link: null,
    dispatch_history: [],
    status: BUNDLE_STATUS.BUILDING,
    created_at: '2026-06-28T05:00:00Z',
  },
];

export const MOCK_STORAGE2 = [
  {
    id: 'st2-1',
    stage2_id: 's2-old-6',
    source_module: 'stage2',
    newspaper_name: 'Sandesh',
    edition: 'Junagadh',
    keyword: [],
    article_link: img('art-11'),
    newspaper_link: img('np-11'),
    page_number: 5,
    archive_path: '/archive/2026/06/st2-1.pdf',
    archived_at: '2026-06-27T05:00:00Z',
    status: 'archived',
    created_at: '2026-06-27T05:00:00Z',
  },
  {
    id: 'st2-2',
    stage2_id: 's2-old-7',
    source_module: 'briefing',
    newspaper_name: 'Mid-Day',
    edition: 'Mumbai',
    keyword: [],
    article_link: img('art-12'),
    newspaper_link: img('np-12'),
    page_number: 2,
    archive_path: '/archive/2026/06/st2-2.pdf',
    archived_at: '2026-06-28T05:00:00Z',
    status: 'archived',
    created_at: '2026-06-28T05:00:00Z',
  },
];

export const MOCK_ACTIVITIES = [
  { id: 'act-1', activity_type: 'article_routed', module: 'stage2', description: 'Article routed to Sahebji Briefing', performed_by: 'Ravi Reviewer', performed_at: '2026-06-29T08:10:00Z' },
  { id: 'act-2', activity_type: 'batch_dispatched', module: 'briefing', description: 'Morning briefing batch #24 dispatched', performed_by: 'system', performed_at: '2026-06-28T03:30:00Z' },
  { id: 'act-3', activity_type: 'bundle_generated', module: 'storage1', description: 'Bundle #12 generated (Divya Bhaskar)', performed_by: 'system', performed_at: '2026-06-26T05:00:00Z' },
  { id: 'act-4', activity_type: 'article_rejected', module: 'stage1', description: 'Article rejected (Doubt)', performed_by: 'Deepak Data', performed_at: '2026-06-28T10:05:00Z' },
  { id: 'act-5', activity_type: 'cron_job_failed', module: 'settings', description: 'Cron "Gujarat Samachar — Vadodara" failed: PDF timeout', performed_by: 'system', performed_at: '2026-06-29T08:05:00Z' },
  { id: 'act-6', activity_type: 'user_created', module: 'settings', description: 'User "Deepak Data" created', performed_by: 'System Admin', performed_at: '2026-06-27T09:00:00Z' },
];
